export default __webpack_public_path__ + "static/aspire-2e0b7693a00ff7a70bd0147f734da5f2.png";